import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Modal from 'components/common/Modal';
import ModalAddNewFeed from 'components/community/components/popup/ModalAddNewFeed';
import { useSelector } from 'store';
import { default_profile } from 'constants/image';
import styled from 'styled-components';

var ViewNewFeed = function ViewNewFeed() {
  var _Modal = Modal(),
      openModal = _Modal.openModal,
      closeModal = _Modal.closeModal,
      ModalPortal = _Modal.ModalPortal;

  var user = useSelector(function (state) {
    return state.accounts.user;
  });
  var profile_image = user.profile.profile_picture !== null ? user.profile.profile_picture : default_profile;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "hgroup",
      children: [/*#__PURE__*/_jsx("span", {
        className: "profile-img",
        style: {
          backgroundImage: "url(".concat(profile_image, ")")
        }
      }), /*#__PURE__*/_jsx(InputWrapper, {
        children: /*#__PURE__*/_jsx("a", {
          onClick: openModal,
          style: {
            cursor: 'pointer',
            color: '#777'
          },
          children: "\uBA64\uBC84\uB4E4\uC5D0\uAC8C \uB2F9\uC2E0\uC758 \uC774\uC57C\uAE30\uB97C \uB4E4\uB824\uC8FC\uC138\uC694 :)"
        })
      })]
    }), /*#__PURE__*/_jsx(ModalPortal, {
      children: /*#__PURE__*/_jsx(ModalAddNewFeed, {
        closeModal: closeModal
      })
    })]
  });
};

var InputWrapper = styled.p.withConfig({
  displayName: "ViewNewFeed__InputWrapper",
  componentId: "sc-5gydcc-0"
})(["border:2px solid lightgray !important;padding:16px 8px !important;border-radius:8px;font-size:16px !important;@media screen and (max-width:786px){font-size:14px !important;}"]);
export default ViewNewFeed;